import {
  upcomingSessionMockHandler,
  upcomingExtraClassesMockHandler,
} from '@/features/sessions/api';

export const sessionsHandlers = [
  upcomingSessionMockHandler,
  upcomingExtraClassesMockHandler,
];
